<script>
import ManualImportForm from "@/views/PaySectionImport/Form/ManualImportForm.vue";
import RefundImportValue from "@/views/PaySectionImport/Form/RefundImportValue.vue";
import MutuelleImportForm from "@/views/PaySectionImport/Form/MutuelleImportForm.vue";
import AbsenceRequestImport from "@/views/PaySectionImport/Form/AbsenceRequestImport";
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import {onMounted, ref} from "vue";
import axios from "axios";
import EvaluationPerformanceImport from "@/views/PaySectionImport/Form/EvaluationPerformanceImport.vue";
import useSharedMethod from "@/use/SharedMethod";

export default {
    components: {
        EvaluationPerformanceImport,
        ManualImportForm,
        RefundImportValue,
        MutuelleImportForm,
        AbsenceRequestImport,
        // PointingImportForm,
    },
    setup() {
        const {loading, dialog} = useSharedData();
        const {$route} = useTools();
        const {getBack} = useSharedMethod();

        const panelModel = ref(0);
        const tab = ref(null);
        const data = ref({
            workers: [],
            filter: {},
        });
        const type = ref("absence_request");
        const firstTypes = ref([
            {id: "absence_request", name: "Absence / Congé"},
            {id: "refund", name: "Prêt"},
            {id: "pay_day_advance", name: "Avance Sur Salaire"},
            {id: "mutuelle", name: "Mutuelle"},
            {id: "pointing", name: "Pointage"},
            {id: "performance", name: "Evaluation Performance"},
        ]);
        const secondTypes = ref([
            {id: "file", name: "Modèle Prédéfinit"},
            {id: "file-free-mode", name: "Fichier Libre"},
        ]);

        const annex = ref({});

        function findAnnexById(id) {
            loading.value = true;
            axios.get(`/paySlipAnnexes/${id}`).then(response => {
                annex.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findAnnexById($route.params.annexId));

        return {
            tab,
            data,
            type,
            firstTypes,
            secondTypes,
            dialog,
            loading,
            panelModel,
            annex,
            getBack,
        }
    }
};
</script>

<template>
    <div>
        <router-view/>
        <v-dialog
            transition="dialog-bottom-transition"
            v-model="dialog"
            persistent
            max-width="1200"
            scrollable
        >
            <v-card>
                <w-toolbar color="teal" :title="`Importation (${annex.name})`"/>
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="4">
                                <v-expansion-panels v-model="panelModel" dense focusable>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <strong>Depuis Module</strong>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="mr-n5 ml-n5">
                                            <v-container fluid>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-radio-group
                                                            v-model="type"
                                                            class=""
                                                            row
                                                        >
                                                            <v-row dense class="mt-n3">
                                                                <v-col cols="12">
                                                                    <v-radio
                                                                        v-for="type in firstTypes"
                                                                        :key="type.id"
                                                                        :label="type.name"
                                                                        :value="type.id"
                                                                    ></v-radio>
                                                                </v-col>
                                                                <v-col cols="6">
                                                                </v-col>

                                                            </v-row>
                                                        </v-radio-group>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <strong>Sources Externes</strong>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="mr-n5 ml-n5">
                                            <v-container fluid>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-radio-group
                                                            v-model="type"
                                                            class=""
                                                            row
                                                            hide-details
                                                        >
                                                            <v-row dense class="mt-n3">
                                                                <v-col cols="12">
                                                                    <v-radio
                                                                        v-for="type in secondTypes"
                                                                        :key="type.id"
                                                                        :label="type.name"
                                                                        :value="type.id"
                                                                    ></v-radio>
                                                                </v-col>

                                                            </v-row>

                                                        </v-radio-group>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                            <v-col cols="8">
                                <fieldset>
                                    <legend>
                                        <strong class="ma-2"> Options </strong>
                                    </legend>
                                    <v-container fluid>
                                        <v-row v-show="type === 'file'" dense>
                                            <v-col cols="12">
                                                <ManualImportForm
                                                    :filter="data.filter"
                                                    :workers="data.workers"
                                                    :annex-id="$route.params.annexId"
                                                ></ManualImportForm>
                                            </v-col>
                                        </v-row>
                                        <v-row v-show="type === 'file-free-mode'" dense>
                                            <v-col cols="12">
                                                <ManualImportForm
                                                    :filter="data.filter"
                                                    :workers="data.workers"
                                                    :annex-id="$route.params.annexId"
                                                    free-mode
                                                ></ManualImportForm>
                                            </v-col>
                                        </v-row>
                                        <v-row v-show="type === 'absence_request'" dense>
                                            <v-col cols="12">
                                                <AbsenceRequestImport
                                                    :filter="data.filter"
                                                    :workers="data.workers"
                                                    :annex-id="$route.params.annexId"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row v-show="type === 'refund'" dense>
                                            <v-col cols="12">
                                                <RefundImportValue
                                                    :filter="data.filter"
                                                    :workers="data.workers"
                                                    :annex-id="$route.params.annexId"
                                                    :type="'NORMAL'"
                                                ></RefundImportValue>
                                            </v-col>
                                        </v-row>
                                        <v-row v-show="type === 'pay_day_advance'" dense>
                                            <v-col cols="12">
                                                <RefundImportValue
                                                    :filter="data.filter"
                                                    :workers="data.workers"
                                                    :annex-id="$route.params.annexId"
                                                    :type="'PAY_DAY_ADVANCE'"
                                                ></RefundImportValue>
                                            </v-col>
                                        </v-row>
                                        <v-row v-show="['mutuelle', 'pointing'].includes(type)" dense>
                                            <v-col cols="12">
                                                <MutuelleImportForm
                                                    :filter="data.filter"
                                                    :workers="data.workers"
                                                    :annex-id="$route.params.annexId"
                                                ></MutuelleImportForm>
                                            </v-col>
                                        </v-row>
                                        <v-row v-show="type === 'performance'" dense>
                                            <v-col cols="12">
                                                <EvaluationPerformanceImport
                                                    :filter="data.filter"
                                                    :workers="data.workers"
                                                    :annex-id="$route.params.annexId"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </fieldset>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>